export interface IBitlockerKey {
  readonly id: string;
  readonly createdDateTime: string;
  readonly volumeType: volumeType;
  readonly deviceId: string;
  readonly key?: string;

  // Delete all properties below this when we migrate to MS graph fully
  readonly creationTime?: string;
  readonly keyIdentifier?: string;
  readonly customKeyInformation?: string;
  readonly keyMaterial?: string;
  readonly driveTypeIndicator?: BitLockerKeyDriveType;
  readonly recoveryKey?: string;
}

export const enum volumeType {
  operatingSystemVolume = '1',
  fixedDataVolume = '2',
  removableDataVolume = '3',
  unknownFutureValue = '4'
}

// Delete this whole class when we migrate to MS Graph fully
export const enum BitLockerKeyDriveType {
  Unspecified = 0,
  OperatingSystem = 1,
  FixedData = 2,
  RemovableData = 3
}

export interface IBitlockerKeyReturnType {
  readonly value: IBitlockerKey[];
}

export interface IBitlockerRecoveryKeyReturnKey {
  readonly bitlockerRecoveryKey: string | undefined;
  readonly wasError: boolean;
}
